import {
  Badge,
  Button,
  Divider,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  HStack,
  Input,
  Link,
  List,
  ListIcon,
  ListItem,
  Stack,
  VStack,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FaTrashAlt } from "react-icons/fa";
import * as Yup from "yup";

// Define validation schema
const profileSchema = Yup.object().shape({
  firstName: Yup.string()
    .max(50, "First name must be less than 50 characters")
    .required("First name is required"),
  lastName: Yup.string()
    .max(50, "Last name must be less than 50 characters")
    .required("Last name is required"),
});

const emails = [
  { address: "leandro.nunez1457@gmail.com", primary: true },
  { address: "lhernandez@synchronit.com"},
  { address: "noreply@synchronit.com" },
];

const Profile = () => {
  return (
    <>
      <Heading size={"md"}>Profile</Heading>
      <Divider borderColor={"gray.300"} />
      <Formik
        initialValues={{
          firstName: "Leandro",
          lastName: "Hernandez",
					phone: ""
        }}
        validationSchema={profileSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            actions.setSubmitting(false);
          }, 1000);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <VStack align={"flex-start"} mb={5} gap={10}>
              <VStack gap={5} align={"flex-start"}>
                <Field name="firstName">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.firstName && form.touched.firstName
                      }
                    >
                      <FormLabel>First Name</FormLabel>
                      <Input {...field} type="text" />
                      <FormHelperText>
                        First name is required once you setted
                      </FormHelperText>
                      <FormErrorMessage>
                        {form.errors.firstName}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="lastName">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form.errors.lastName && form.touched.lastName}
                    >
                      <FormLabel>Last Name</FormLabel>
                      <Input {...field} type="text" />
                      <FormHelperText>
                        Last name is required once you setted
                      </FormHelperText>
                      <FormErrorMessage>
                        {form.errors.lastName}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
								<Field name="phone">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={form.errors.phone && form.touched.phone}
                    >
                      <FormLabel>Phone</FormLabel>
                      <Input {...field} type="text" />
                      <FormHelperText>
                        Phone number can be empty. You can remove it any time
                      </FormHelperText>
                      <FormErrorMessage>
                        {form.errors.phone}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Button
                  type="submit"
                  colorScheme="blue"
                  isLoading={isSubmitting}
                  loadingText="Saving..."
                >
                  Save Profile
                </Button>
              </VStack>

              <VStack align={"flex-start"} gap={5}>
                <Heading size={"sm"}>Emails</Heading>
                <List spacing={3} width={"100%"} mb={0}>
                  {emails.map(({ address, primary }, i) => {
                    return (
                      <ListItem justifyContent={"baseline"}>
                        <Stack direction={"row"} align={"baseline"}>
                          <ListIcon as={FaTrashAlt} color={"red.400"} />
                          <Link variant={"intense-blue"} href="#">
                            {address}
                          </Link>
                          {primary && (
                            <Badge
                              variant={"outline"}
                              colorScheme={primary ? "purple" : "gray"}
                              borderRadius={"md"}
                            >
                              {"primary"}
                            </Badge>
                          )}
                        </Stack>
                      </ListItem>
                    );
                  })}
                </List>

                <FormControl>
                  <FormLabel>Add email address</FormLabel>
                  <HStack>
                    <Input type="email" placeholder="Email address"/>
                    <Button variant={"outline"}>Add</Button>
                  </HStack>
                </FormControl>
              </VStack>
            </VStack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Profile;
